<template>
  <div class="home">
    <div ref="qqMap" id="qqMap" class="map"></div>

    <div class="head-wrap bg-color">
      <div class="head" :class="isBgColor ? 'bg-color' : ''">
        <div class="time"><span>2022-08-22</span><span>&nbsp;星期一</span></div>
        <div class="head-title">
          <div class="head-title-bg"></div>
        </div>
        <div class="full-screen">
          <span class="full-screen-title" @click="screen">
            「 {{ fullscreen ? "退出" : title }} 」
          </span>
        </div>
      </div>
    </div>

    <div class="left bg-color" v-show="isShow">

        <div class="box-wrap box-bg">
          <div class="box-content left-mg">
            <div class="box-content-text">
              <span>平台注册用户100000人</span>
              <div class="rate-wrap">
                <div class="rate-wrap-item">
                  <div class="item-circle" id="test">圆</div>
                  <div class="item-text">活跃会员占比</div>
                </div>

                <div class="rate-wrap-item">
                  <div class="item-circle" id="test2">圆</div>
                  <div class="item-text">消费会员占比</div>
                </div>

                <div class="rate-wrap-item">
                  <div class="item-circle" id="test3">圆</div>
                  <div class="item-text">新增用户占比</div>
                </div>

                <div class="rate-wrap-item">
                  <div class="item-circle" id="test4">圆</div>
                  <div class="item-text">新增会员占比</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-wrap box-bg">
          <div class="box-content left-mg">
            <div class="box-content-text">
              <div class="box-content-head">
                <span>设备数量</span>
                <span class="head-num">设备总台数1000台</span>
              </div>
              <div>
                <div id="equipment"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-wrap box-bg">
          <div class="box-content left-mg">
            <div class="box-content-text">
              <div class="box-content-head">
                <span>门店数量</span>
                <span class="head-num">总门店数：300</span>
              </div>
              <div>
                <div id="store"></div>
              </div>
            </div>
          </div>
        </div>


    </div>


    <div class="main">
        <div>
          <div class="container-head">
            <div class="container-head-address">
              <img class="head-img" src="../assets/image/home/address.png" />
              <span class="head-title">广东省深圳市</span>
            </div>
            <!-- <img class="head-bg" src="../assets/image/home/head-bg.png" alt="" /> -->
          </div>
          <div class="container-type">
            <div class="container-type-text color-1">
              洗车机
              <!-- <span class="container-type-text-flag bg-color-1"></span> -->
              <img class="type-img" src="../assets/image/home/type-1.png" alt="">
            </div>
            <div class="container-type-text color-2">
              钢琴
              <!-- <span class="container-type-text-flag bg-color-2"></span> -->
              <img class="type-img" src="../assets/image/home/type-2.png" alt="" />
            </div>
            <div class="container-type-text color-3">
              量子仪器
              <!-- <span class="container-type-text-flag bg-color-3"></span> -->
              <img class="type-img" src="../assets/image/home/type-3.png" alt="" />
            </div>
            <div class="container-type-text color-4">
              陪护床
              <!-- <span class="container-type-text-flag bg-color-4"></span> -->
              <img class="type-img" src="../assets/image/home/type-4.png" alt="" />
            </div>
          </div>
          <div class="container-footer">
            <div id="equipment-ratio"></div>
          </div>
          <div class="equipment-ratio-bg"></div>
          <div class="equipment-ratio-circle"></div>
          <!-- <div class="footer-bg"></div> -->
        </div>
      </div>



    <div class="right bg-color" v-show="isShow">

      <div class="box-wrap order-frame right-mt">
          <div class="box-content right-mg">
            <div class="box-content-text">
              <div class="box-content-head">
                <span>订单数据</span>
                <span class="head-num">总计订单：80万</span>
              </div>
              <div>
                <div id="order-data"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-wrap-order order-info">
          <div class="box-content right-mg order-height">
            <div class="box-content-text">
              <div class="box-content-head">
                <span>订单信息</span>
                <span class="head-num">今日营收：10万</span>
              </div>
              <div class="order-list">

                <ul>
                  <li class="order-head">
                    <div class="order-row">
                      <div>用户</div>
                      <div>设备类型</div>
                      <div>消费金额</div>
                      <div>消费时间</div>
                    </div>
                  </li>
                  <vue-seamless-scroll :data="orderInfoList" class="seamless-warp">
                  <li class="order-content" v-for="(item, index) in orderInfoList" :key="index">
                    <div class="order-row">
                      <div>{{ item.name }}</div>
                      <div>{{ item.type }}</div>
                      <div>{{ item.money }}</div>
                      <div>{{ item.time }}</div>
                    </div>
                  </li>
                  </vue-seamless-scroll>
                  
                </ul>

              </div>
            </div>
          </div>
        </div>


    </div>


  </div>
</template>

<script>
import * as echarts from "echarts";
import vueSeamlessScroll from 'vue-seamless-scroll'
import screenfull from "screenfull";
// import DevicePixelRatio from '@/devicePixelRatio';

export default {
  data() {
    return {
      isShow: true,
      fullscreen: false,
      title: "全屏",
      orderInfoList: [
        {
          id: '1',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '2',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '3',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '4',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '5',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '6',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '7',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
        {
          id: '8',
          name: '张依依',
          type: '洗车机',
          money: 50,
          time: '2022-08-02'
        },
      ],
      //地图坐标
      mapData:[
        {
          lat:39.88375,
          lng:116.27488,
          styleId:'inspect'
        },
        {
          lat:39.89575,
          lng:116.28988,
          styleId:'inspect'
        },
        {
          lat:39.97653,
          lng:116.46142,
          styleId:'construction'
        },
        {
          lat:39.98653,
          lng:116.47142,
          styleId:'construction'
        },
        {
          lat:40.00435,
          lng:116.26792,
          styleId:'other'
        },
        {
          lat:40.02635,
          lng:116.26992,
          styleId:'other'
        },
        {
          lat:39.81983,
          lng:116.31502,
          styleId:'accident'
        },
        {
          lat:39.83183,
          lng:116.31402,
          styleId:'accident'
        },
      ],
      option: {
        xAxis: {
          type: "category",

          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },

        yAxis: {
          type: "value",
        },

        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],

            type: "line",
          },
        ],
      },


      //圆
      option3: {
        title: {
          show: true,
          text: 60 + "%",
          x: "center",
          y: "center", // 通过x,y将标题(进度)定位在圆环中心
          // backgroundColor:'red',
          textStyle: {
            fontSize: "18",
            color: "#2BB6D5",
            fontWeight: "400",
            fontFamily: "DINPro, DINPro-Regular",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: false,
        },
        legend: {
          orient: "vertical",
          x: "left",
          show: false,
        },

        series: [
          {
            color: ["#ffffff"],
            type: "pie",
            radius: "80%",
            center: ["50%", "50%"],
            data: [{ value: 100, name: "" }],
            emphasis: { scale: false },
            label: { show: false },
          },
          {
            type: "pie",
            radius: ["80%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,

            data: [
              {
                value: 60,
                name: "",
                itemStyle: {
                  color: "#2AB296",
                },
              },
              {
                value: 100 - 60,
                name: "",
                itemStyle: {
                  color: "#e6ebf2",
                  // color: "transparent", //透明色，也可以设置把其他颜色
                },
              },
            ],

            emphasis: { scale: false },
            label: { show: false },
          },
        ],

      },

      //设备数量
      option4: {
        barWidth: 15,
        tooltip: {},
        grid: {
          x: 40,
          y: 20,
          x2: 50,
          y2: 60, //距离下边的距离
        },
        // legend: {
        //     data:['销量']
        // },
        xAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          data: ["洗车机", "钢琴", "量子仪器", "陪护床"],
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            // name: "销量",
            type: "bar",
            data: [210, 380, 700, 410],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  // color: '#248ff7'
                  color: "#23C2E4",
                },
                {
                  offset: 1,
                  // color: 'rgba(22,75,247,0.1)'
                  // color: '#0D3F99'
                  color: "rgba(13,63,153,0)",
                },
              ]),
            },
          },
        ],
      },

      //门店数据  #35dca6  #35dca6
      option5: {
        barWidth: 15,
        tooltip: {},
        grid: {
          x: 40,
          y: 20,
          x2: 50,
          y2: 60, //距离下边的距离
        },
        // legend: {
        //     data:['销量']
        // },
        xAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          // boundaryGap: false,
          // boundaryGap: [0,-10],
          data: ["8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7"],
        },
        yAxis: {
          type: "value",
          // scale: true,
          splitLine: { show: false },
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            // name: "销量",
            type: "line",
            data: [5, 20, 36, 10, 10, 20, 30],
            color: "#35dca6",
            // itemStyle: {
            // color:'#35DCA6',
            // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //   {
            //     offset: 0,
            //     // color: '#248ff7'
            //     color: "#23C2E4",
            //   },
            //   {
            //     offset: 1,
            //     // color: 'rgba(22,75,247,0.1)'
            //     // color: '#0D3F99'
            //     color: "rgba(13,63,153,0)",
            //   },
            // ]),
            // },

            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#248f99" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "#0f4290" },
                ]),
              },
            }, //填充区域样式
            // lineStyle: {
            //   color: "#00b5ff",
            //   opacity: 1
            // },//线条的样式
            // itemStyle: {
            //   color: "rgb(255, 70, 131)",
            //   opacity: 0 //为0不会绘制图形拐点消失
            // } //拐点的样式
          },

          // },
        ],
      },

      //订单数据
      option6: {
        barWidth: 15,
        tooltip: {},
        grid: {
          x: 40,
          y: 10,
          x2: 50,
          y2: 60, //距离下边的距离
        },
        // legend: {
        //     data:['销量']
        // },
        xAxis: {
          // splitLine:{show:false},
          type: "category",
          axisTick: {
            show: false, //坐标轴刻度线
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          // boundaryGap: false,
          data: ["8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7"],
        },
        yAxis: {
          type: "value",
          // scale: true,
          splitLine: { show: false },
          axisLabel: {
            formatter: "{value}",
            color: "#ffffff",
            //坐标轴样式
            textStyle: {
              color: "#ffffff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff",
            },
            //轴线
            // show: false,
          },
          axisTick: {
            show: false, //坐标轴刻度线
          },
        },
        series: [
          {
            // name: "销量",
            type: "line",
            data: [2000, 3000, 1500, 5900, 3200, 4000, 5000],
            color: "#35dca6",
            // itemStyle: {
            // color:'#35DCA6',
            // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //   {
            //     offset: 0,
            //     // color: '#248ff7'
            //     color: "#23C2E4",
            //   },
            //   {
            //     offset: 1,
            //     // color: 'rgba(22,75,247,0.1)'
            //     // color: '#0D3F99'
            //     color: "rgba(13,63,153,0)",
            //   },
            // ]),
            // },

            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#248f99" },
                  // { offset: 0.5, color: "pink" },
                  { offset: 1, color: "#0f4290" },
                ]),
              },
            }, //填充区域样式
            // lineStyle: {
            //   color: "#00b5ff",
            //   opacity: 1
            // },//线条的样式
            // itemStyle: {
            //   color: "rgb(255, 70, 131)",
            //   opacity: 0 //为0不会绘制图形拐点消失
            // } //拐点的样式
          },

          // },
        ],
      },

      //底部 设备占
      option8: {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        // tooltip: {
        //   trigger: 'item'
        // },
        legend: {
          orient: "vertical",
          top: "34%",
          left: "33%",
          // left: 'right',
          data: [
            {
              icon: "circle",
              id: "1",
              name: "正常运行设备8000台",
              // textStyle: { color: "#ffffff", fontSize: "14px" },
              textStyle: { color: "#000", fontSize: "14px" },
            },
            {
              icon: "circle",
              id: "2",
              name: "异常设备200台",
              // textStyle: { color: "#ffffff", fontSize: "14px" },
              textStyle: { color: "#000", fontSize: "14px" },
            },
          ],
        },
        color: ["#e67777", "#34e1be"],

        series: [
          {
            // name: 'Access From',
            type: "pie",
            center: ["15%", "50%"],
            radius: ["0%", "80%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                // position:'right',
                formatter: "{c} %",
                textStyle: {
                  color: "#ffffff",
                  // color:'red',
                  fontSize: "14px",
                },
              },
            },
            labelLine: { show: false },
            // silent:true, //去掉鼠标经过放大效果
            data: [
              {
                value: 25,
                name: "正常运行设备8000台",
              },
              {
                value: 75,
                name: "异常设备200台",
                // labelLine:{show:false},
              },
              // labelLine:{
              //   show:fale,
              // },
            ],
            // emphasis: {
            //   label:false,
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // }


          },
        ],
      },
    };
  },
  components: {
    vueSeamlessScroll,
  },
  created() {
    // new DevicePixelRatio().init();
	},
  mounted() {
    this.initMap2()
    // this.initQQMap();
    // this.initMap()
    
    //平台注册用户
    const myChart = echarts.init(document.querySelector("#test"));
    myChart.setOption(this.option3);

    const test2 = echarts.init(document.querySelector("#test2"));
    test2.setOption(this.option3);

    const test3 = echarts.init(document.querySelector("#test3"));
    test3.setOption(this.option3);

    const test4 = echarts.init(document.querySelector("#test4"));
    test4.setOption(this.option3);

    //设备数量
    const equipmentChart = echarts.init(document.querySelector("#equipment"));
    equipmentChart.setOption(this.option4);

    //门店数量
    const storeChart = echarts.init(document.querySelector("#store"));
    storeChart.setOption(this.option5);

    //订单数据
    const orderDataChart = echarts.init(document.querySelector("#order-data"));
    orderDataChart.setOption(this.option6);

    //底部 设备占比
    const option8 = echarts.init(document.querySelector("#equipment-ratio"));
    option8.setOption(this.option8);



  },
  methods:{

    //全屏
    screen() {
      this.isShow = !this.isShow;
      // if (!screenfull.isEnabled) {
      //   this.$message("您的浏览器不能全屏");
      //   return false;
      // }
      // this.fullscreen = !this.fullscreen;
      // screenfull.toggle();
    },



    //接入地图
    initMap2() {
      //初始化地图
      var map = new TMap.Map(this.$refs.qqMap, {
        zoom: 11.2, //设置地图缩放级别
        pitch: 30,//设置俯仰角
        // zoomControl:false,
        // control:false,

        // panControl: false,         //平移控件的初始启用/停用状态。
        //         zoomControl: false,       //缩放控件的初始启用/停用状态。
        //         scaleControl: false,        //滚动控件的初始启用/停用状态。

        center: new TMap.LatLng(39.94777457424578, 116.40822675986203), //设置地图中心点坐标
        // mapStyleId: "marker", //个性化样式 
        // mapStyleId: "style2", //个性化样式 黑色背景
        mapStyleId: "style", //个性化样式 白色背景
        // mapStyleId: "bluish", //个性化样式
        backgroundColor: "#000000",
        draggableCursor: "crosshair",
        // mapTypeControl:false,
        // zoomControlOptions:{
        //   //设置缩放控件的位置为相对左方中间位置对齐.
        //             position: 'right',
        //             //设置缩放控件样式为仅包含放大缩小两个按钮
        //             style: 'small'
        // },

        // removeControl:DEFAULT_CONTROL_ID.SCALE,

        // mapStyle:{style:"bluish"},
        baseMap: {
          type: "vector",
          features: ["base", "building3d"], // 隐藏矢量文字
        },
      });

      map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE);
      // map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)
      map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);

      var control = map.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
      // control.setPosition(TMap.constants.CONTROL_POSITION.BOTTOM_RIGHT);

      control.setPosition(TMap.constants.CONTROL_POSITION.BOTTOM_CENTER);

      

      // 获取缩放控件实例
      //  var  control = map.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);

      //   // 把存储的缩放控件添加到地图上
      // function addControl() {
      //   map.addControl(control);

      // }

      //   function setPosition(position) {
      //     if (!control) {
      //       return;
      //     }
      //     switch (position) {
      //       case 'center':
      //         control.setPosition(TMap.constants.CONTROL_POSITION.CENTER);
      //         break;
      //       case 'bottomRight':
      //         control.setPosition(TMap.constants.CONTROL_POSITION.BOTTOM_RIGHT);
      //         break;
      //     }
      //  }

      console.log(1,dotData)
      //初始化散点图并添加至map图层
      var dot = new TMap.visualization.Dot({
        styles: {
          accident: setStyles("accident"),
          construction: setStyles("construction"),
          inspect: setStyles("inspect"),
          other: setStyles("other"),
        },
      }).addTo(map);
      // dot.setData(dotData); //设置数据
      dot.setData(this.mapData);

      function setStyles(name) {
        return {
          type: "image", //设置图片
          width: 20, //宽度
          height: 20, //高度
          anchor: { x: 10, y: 10 }, //图片锚点位置
          src: `https://mapapi.qq.com/web/lbs/visualizationApi/demo/img/${name}.png`, //图片样式属性
        };
      }
    },




     // 地图初始化函数，本例取名为init，开发者可根据实际情况定义
    //  initMap () {
    // // 定义地图中心点坐标
    //   var center = new window.TMap.LatLng(39.984120, 116.307484)
    //   // 定义map变量，调用 TMap.Map() 构造函数创建地图
    //   var map = new window.TMap.Map(this.$refs.qqMap, {
    //     center: center, // 设置地图中心点坐标
    //     zoom: 17.2, // 设置地图缩放级别
    //     pitch: 43.5, // 设置俯仰角
    //     rotation: 45 // 设置地图旋转角度
    //   })
    //   // 初始化marker
    //   var marker = new window.TMap.MultiMarker({
    //     id: 'marker-layer', // 图层id
    //     map: map,
    //     styles: { // 点标注的相关样式
    //       marker: new window.TMap.MarkerStyle({
    //         width: 25,
    //         height: 35,
    //         anchor: { x: 16, y: 32 },
    //         src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
    //       })
    //     },
    //     geometries: [{ // 点标注数据数组
    //       id: 'demo',
    //       styleId: 'marker',
    //       position: new window.TMap.LatLng(39.984104, 116.307503),
    //       properties: {
    //         title: 'marker'
    //       }
    //     }]
    //   })
    //   console.log(map)
    //   console.log(marker)
    //   // 去除logo及水印，开发文档中也有去除LOGO的方法，但不能去除左下角信息
    //   var a = document.querySelector('canvas+div:last-child')
    //   a.style.display = 'none'
    // },


    // initQQMap(){
    //   var center = new TMap.LatLng(39.94777457424578, 116.40822675986203)
    //   // var center = new TMap.LatLng(50.11,8.68)
    //   // center: new TMap.LatLng(39.94777457424578, 116.40822675986203), //设置地图中心点坐标
    //   var map = new TMap.Map(this.$refs.qqMap, {
    //     center: center,//设置地图中心点坐标
    //     zoom: 11.2,   //设置地图缩放级别
    //     pitch: 0,  //设置俯仰角

    //             mapStyleId: "style2", //个性化样式 黑色背景
    //             // mapStyleId: "style", //个性化样式 白色背景


    //   });

    //   map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE);
    //   // map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)
    //   map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);

    //   var control = map.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
    //   control.setPosition(TMap.constants.CONTROL_POSITION.BOTTOM_RIGHT);

    //   // var opts = {
    //   //     offset: new BMapGL.ZoomControl(150, 5)
    //   // }
    //   // // 添加控件
    //   // map.addControl(new BMapGL.ZoomControl(opts));

    //   // map.removeControl(new BMapGL.ScaleControl(opts));

    //   // var scaleCtrl = new BMapGL.ScaleControl();  // 添加比例尺控件
    //   // map.addControl(scaleCtrl);
    //   // var zoomCtrl = new BMapGL.ZoomControl();  // 添加缩放控件
    //   // map.addControl(zoomCtrl);
    //   // var cityCtrl = new BMapGL.CityListControl();  // 添加城市列表控件
    //   // map.addControl(cityCtrl);

    //   // map.removeControl(scaleCtrl);
    //   // map.removeControl(zoomCtrl);
    //   // map.removeControl(cityCtrl);

    //   // map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE);
    //   // map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)
    //   // map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);

    //   // var mapStyle = { style:'dark' }
    //   // map.setMapStyle(mapStyle);

    //   // var myStyleJson=[
    //   //         {
    //   //         "featureType": "road",
    //   //         "elementType": "geometry.stroke",
    //   //         "stylers": {
    //   //         "color": "#ff0000"
    //   //         }
    //   //     }];
    //   //   map.setMapStyle({styleJson: myStyleJson });

    // },
  },
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-image: radial-gradient(transparent 50%,#000 90%);
}
.map {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.head-wrap{
  width: 100%;
  height: 100px;
  position: absolute;
  top: 0;
  z-index: 2001;
}
.head {
    position: absolute;
    top: 0;
    left: 50%;
    display: flex;
    justify-content: space-between;
    // height: 6.25rem;
    height: 100px;
    background: url("../assets/image/home/head.png") no-repeat;
    // background: url("../assets/image/home/Group-2.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    transform: translateX(-50%);
    z-index: 2001;

    .time {
      width: 543px;
      margin-top: 26px;
      margin-left: 46px;
      // color: var(--theme-text-color);
      color: #ffffff;
    }

    .head-title {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;

      .head-title-bg {
        width: 464px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: url("../assets/image/home/head-title.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .full-screen {
      width: 543px;
      margin-top: 33px;
      margin-right: 33px;
      // color: var(--theme-text-color);
      color: #ffffff;
      text-align: right;

      .full-screen-title {
        cursor: pointer;
      }
    }
  }

  .left{
    position: absolute;
    left: 0;
    // top: 6.25rem;
    top: 100px;
    // height: calc(100% - 6.25rem);
    height: calc(100% - 100px);
    width: 30%;
    z-index: 2001;
    // background-color: red;
    // background-color: rgba(9,29,126,.7);
    // background-color: rgba(19, 74, 165,.4);
  }
  
  .right{
    position: absolute;
    right: 0;
    // top: 6.25rem;
    // height: calc(100% - 6.25rem);
    top: 100px;
    height: calc(100% - 100px);
    width: 30%;
    z-index: 2001;
    // background-color: gold;
    // background-color: rgba(9,29,126,.7);
    // background-color: rgba(19, 74, 165,.4);
  }

  /deep/ .tmap-zoom-control {
  background: #3ccbbc;
  margin: 10px 30px 35px;
  left: 320px;
  cursor: pointer;
}

</style>




<style lang="less" scoped>
  .home {
    // height: 1080px;
    // height: 100vh;
    // min-height: 937;
    // height: 100%;
    // overflow: hidden;
    // background: url("../assets/image/home/bg.png") no-repeat top center;
    // background-size: 100% 100%;
    // background-color: #012980;
  
    // .head {
    //   display: flex;
    //   justify-content: space-between;
    //   height: 6.25rem;
    //   background: url("../assets/image/home/head.png") no-repeat;
    //   background-size: 100% 100%;
    //   overflow: hidden;
  
    //   .time {
    //     width: 543px;
    //     margin-top: 26px;
    //     margin-left: 46px;
    //     color: var(--theme-text-color);
    //   }
  
    //   .head-title {
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     flex: 1;
  
    //     .head-title-bg {
    //       width: 464px;
    //       height: 56px;
    //       line-height: 56px;
    //       text-align: center;
    //       background: url("../assets/image/home/head-title.png") no-repeat;
    //       background-size: 100% 100%;
    //     }
    //   }
  
    //   .full-screen {
    //     width: 543px;
    //     margin-top: 33px;
    //     margin-right: 33px;
    //     color: var(--theme-text-color);
    //     text-align: right;
  
    //     .full-screen-title {
    //       cursor: pointer;
    //     }
    //   }
    // }
  
    .content-wrap {
      display: flex;
  
      .left {
        // width: 543px;
        width: 20%;
        background-color: #00ffad;
        position: absolute;
        left: 0;
        top: 0;
      }
  
      .main {
        position: relative;
        flex: 1;
        height: 827px;
      }
  
      .right {
        width: 543px;
      }
    }
  }
  
  #container {
    position: absolute;
    left: 0;
    top: 0;
    height: 827px;
    min-width: 400px;
    min-height: 600px;
    cursor: pointer;
    overflow: hidden;
  }
  
  .container-head {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    left: 30%;
    // top: 7.25rem;
    top: 116px;
    height: 34px;
    line-height: 34px;
  
    .container-head-address {
      display: flex;
    }
  
    .head-img {
      width: 27px;
      height: 33px;
      line-height: 33px;
      margin: 0 20px 0 22px;
    }
  
    .head-title {
      font-size: 24px;
      color: #00ffad;
    }
  
    .head-bg {
      height: 34px;
      width: 340px;
      margin-right: 10px;
    }
  }
  
  .container-type {
    position: absolute;
    right: 32%;
    // top: 6.25rem;
    top: 100px;
    font-size: 16px;
    color: #fff;
    margin-top: 20px;
    text-align: right;
  
    div {
      margin-bottom: 9px;
    }
  
    .container-type-text {
      position: relative;
  
      .container-type-text-flag {
        display: inline-block;
        position: absolute;
        top: 6px;
        right: -15px;
        height: 10px;
        width: 10px;
        border-radius: 50%;
      }
    }
  }
  
  .color-1 {
    color: #ffc800;
  }
  
  .bg-color-1 {
    background-color: #f7b12a;
  }
  
  .color-2 {
    color: #ff8100;
  }
  
  .bg-color-2 {
    background-color: #c273f0;
  }
  
  .color-3 {
    color: #00b766;
  }
  
  .bg-color-3 {
    background-color: #94dd63;
  }
  
  .color-4 {
    color: #df0000;
  }
  
  .bg-color-4 {
    background-color: #e04bad;
  }
  
  .container-footer {
    position: absolute;
    left: 30%;
    bottom: 40px;
    height: 130px;
    width: 500px;
    z-index: 10001;
  }
  
  #equipment-ratio {
    height: 100%;
    width: 100%;
  }
  
  .equipment-ratio-bg {
    position: absolute;
    left: 31%;
    bottom: 48px;
    background-color: #ffffff;
    width: 114px;
    height: 114px;
    border-radius: 50%;
  }
  .equipment-ratio-circle{
    position: absolute;
    left: 30%;
    bottom: 30px;
    width: 150px;
    height: 150px;
    background-color: red;
    background: url('../assets/image/home/circle.png') no-repeat;
    background-size: 100% 100%;
  }
  
  .footer-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 36px;
    width: 100%;
    background: url("../assets/image/home/footer-bg.png") no-repeat;
    background-size: 100% 100%;
  }
  
  .box-wrap {
    height: 282px;
    // margin-top: -12px;
    // margin-bottom: 6px;
    color: #3d95fc;
    overflow: hidden;
  }
  
  .box-wrap-order {
    height: 569px;
    margin-top: -12px;
    margin-bottom: 6px;
    color: #3d95fc;
    overflow: hidden;
  }
  
  .box-content {
    height: 92%;
    border-radius: 30px 30px 30px 30px;
    // background: rgba(61, 149, 252, 0.2);
    background-color: #1d50b0;
  
    .box-content-text {
      color: #38dca1;
      padding: 20px 0 0 20px;
      font-family: MicrosoftYaHei-Bold-, MicrosoftYaHei-Bold;
  
      .box-content-head {
        display: flex;
        justify-content: space-between;
        margin-right: 34px;
        margin-top: -6px;
      }
  
      #test {
        height: 80px;
        width: 80px;
      }
  
      .rate-wrap {
        display: flex;
        flex-flow: row wrap;
        margin-top: 10px;
  
        div {
          width: 50%;
          margin-bottom: 10px;
        }
  
        .rate-wrap-item {
          display: flex;
          align-items: center;
  
          .item-circle {
            height: 80px;
            width: 80px;
            margin-right: 20px;
          }
  
          .item-text {
            color: #ffffff;
            font-size: 18px;
          }
        }
      }
  
      .head-num {
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
  
  .left-mg {
    margin: 17px 3px 27px 14px;
  }
  
  .right-mg {
    margin: 20px 14px 18px 4px;
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .order-list {
    margin: 10px 34px 0 0;
  
    li {
      height: 52px;
      line-height: 51px;
      background: rgba(48, 190, 232, 0.3);
  
      &:hover {
        background-color: #165890;
      }
    }
  
    .order-head {
      border-left: 1px solid #00ffad;
      border-top: 1px solid #00ffad;
      border-right: 1px solid #00ffad;
      border-bottom: 1px solid #2fbee8;
      background-image: linear-gradient(#22738e, #226ca6);
    }
  
    .order-row {
      display: flex;
      align-content: center;
  
      div {
        flex: 1;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
      }
    }
  
    .order-content {
      border-left: 1px solid #2fbee8;
      border-right: 1px solid #2fbee8;
      border-bottom: 1px solid #2fbee8;
    }
  }
  
  .order-height {
    height: 96%;
  }
  
  #equipment {
    width: 100%;
    height: 250px;
  }
  
  #store {
    height: 250px;
    width: 100%;
  }
  
  #order-data {
    height: 250px;
    width: 100%;
  }
  
  .box-bg {
    background: url("../assets/image/home/box.png") no-repeat;
    background-size: 100% 100%;
    margin-top: -6px;
  }
  
  .order-frame {
    background: url("../assets/image/home/order-frame.png") no-repeat;
    background-size: 100% 100%;
  }
  
  .order-info {
    background: url("../assets/image/home/order-info.png") no-repeat;
    background-size: 100% 100%;
  }
  
  .right-mt {
    margin-top: -10px;
  }
  
  /deep/ .tmap-zoom-control {
    background: #3ccbbc;
    margin: 10px 30px 35px;
  }
  
  /deep/ #qqMap div:nth-child(2) a:nth-child(1) {
    display: none !important;
  }
  
  /deep/ #qqMap div:nth-child(3) div:nth-child(2) span:nth-child(1) {
    display: none !important;
  }
  
  /deep/ .logo-text {
    display: none !important;
  }
  
  .seamless-warp {
    height: 424px;
    overflow: hidden;
  }
  .type-img{
    vertical-align: middle;
    // height: 1.25rem;
    // width: 1.25rem;
    height: 20px;
    width: 20px;
  }

  /* 标准写法 */
:fullscreen { 
  .box-wrap, .box-wrap-order{
    height: auto !important;
  }
  .box-content,.order-height{
    height: 100%;
  }
}

.bg-color {
  // background-color: #4e4c4f;
  background-color: #fffeff;
}
</style>


// WEBPACK FOOTER //
// src/views/HomeAll.vue